/* SXF shop browser — client-side masonry over the public products JSON, filtered by "Subject: …" tags.
   Only product types Original Artwork + Drawn to Order ever enter the browser (merch and home decor stay apart).
   Modes (data-mode):
     compact    = search + family chips + capped masonry + "see all" button (homepage)
     full       = search + family chips + kind/size/sort tools + endless masonry (/pages/browse)
     chips      = family chips linking to the subject collections (collection pages)
     collection = masonry of one collection, newest first, no chips (Fresh Off The Drawing Board) */
(function () {
  var roots = document.querySelectorAll('[data-sxf-browse]');
  if (!roots.length) return;

  var ART_TYPES = ['Original Artwork', 'Drawn to Order'];
  /* families: a handful of doors, each opening onto the specific subjects — nobody has to face 19 chips at once */
  var FAMILIES = [
    ['Trees', 'subject-trees', [['Redwoods', 'subject-redwoods'], ['Willows', 'subject-willows'], ['Cypress Trees', 'subject-cypress'], ['Pines & Bonsai', 'subject-pines-bonsai'], ['Birch Trees', 'subject-birch'], ['Cherry Blossoms & Maples', 'subject-cherry-blossoms'], ['Oaks', ''], ['Palms', ''], ['Tree Houses', 'subject-tree-houses'], ['Forests & Groves', 'subject-forests']]],
    ['Wood Grain', 'subject-wood-grain', [['Eyes in the Grain', 'subject-eyes'], ['Drawings of Drawings', 'subject-drawings-of-drawings'], ['Furniture & Objects', 'subject-objects']]],
    ['Water & Waves', 'subject-water', [['Boats', '']]],
    ['Sunsets & Skies', 'subject-sunsets', [['Mountains & Landscapes', 'subject-landscapes']]],
    ['Flowers & Bouquets', 'subject-flowers', []],
    ['Animals', 'subject-animals', [['Beavers', 'subject-beavers']]]
  ];
  var SIZES = [['Extra Small', 'XS'], ['Small', 'S'], ['Medium', 'M'], ['Large', 'L'], ['Extra Large', 'XL']];
  var KINDS = [['original', 'Originals'], ['drawn to order', 'Drawn to order']];

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(n) { n = Number(n); return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); }
  function param(name) { try { return new URL(location.href).searchParams.get(name) || ''; } catch (e) { return ''; } }
  function familyOf(subject) { for (var i = 0; i < FAMILIES.length; i++) { if (FAMILIES[i][0] === subject) return FAMILIES[i]; for (var j = 0; j < FAMILIES[i][2].length; j++) if (FAMILIES[i][2][j][0] === subject) return FAMILIES[i]; } return null; }
  function familySubjects(f) { return [f[0]].concat(f[2].map(function (c) { return c[0]; })); }

  function load(url, key, cb) {
    try { var c = sessionStorage.getItem(key); if (c) { var o = JSON.parse(c); if (Date.now() - o.t < 600000) return cb(o.p); } } catch (e) {}
    fetch(url).then(function (r) { return r.json(); }).then(function (j) {
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), p: j.products })); } catch (e) {}
      cb(j.products || []);
    }).catch(function () { cb([]); });
  }

  function parse(products, requireSubject) {
    var out = [];
    products.forEach(function (p) {
      var subjects = (p.tags || []).filter(function (t) { return t.indexOf('Subject: ') === 0; }).map(function (t) { return t.slice(9); });
      var img = p.images && p.images[0];
      if (ART_TYPES.indexOf(p.product_type) < 0 || (requireSubject && !subjects.length) || !img || !img.width || !img.height) return;
      var t = p.title || '';
      var num = (t.match(/#(\d{3,5})/) || [])[1];
      var dims = (t.match(/\(([\d.]+\s*x\s*[\d.]+)"?\)/) || [])[1];
      var kind = p.product_type === 'Drawn to Order' ? 'drawn to order' : 'original';
      var prices = (p.variants || []).map(function (v) { return Number(v.price); });
      var avail = (p.variants || []).some(function (v) { return v.available; });
      var min = Math.min.apply(null, prices), max = Math.max.apply(null, prices);
      var sizeTags = (p.tags || []).filter(function (x) { return SIZES.some(function (s) { return s[0] === x; }); });
      var name = t.replace(/\s*\(.*$/, '').replace(/,?\s*(Printed|Woven|Hand-Drawn) to Order.*$/i, '').replace(/\s*[·—-]\s*Pick a Number.*$/i, '');
      out.push({
        handle: p.handle, name: name,
        meta: [dims ? dims.replace(/\s/g, '') + '"' : '', kind === 'drawn to order' ? 'drawn to order' : (num ? 'original #' + num : 'original')].filter(Boolean).join(' · '),
        price: min, priceText: (min !== max ? 'from ' : '') + money(min), avail: avail,
        src: img.src, w: img.width, h: img.height, ar: img.width / img.height,
        subjects: subjects, sizes: sizeTags, kind: kind, created: Date.parse(p.created_at) || 0,
        hay: (t + ' ' + subjects.join(' ') + ' ' + (p.tags || []).join(' ')).toLowerCase()
      });
    });
    return out;
  }

  function imgUrl(src, width) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width; }

  function init(root) {
    var mode = root.getAttribute('data-mode') || 'compact';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 12;
    var freshSkip = parseInt(root.getAttribute('data-fresh-skip'), 10) || 12;
    var browseUrl = root.getAttribute('data-browse-url') || '/pages/browse';
    var collection = root.getAttribute('data-collection') || '';
    var chipsEl = root.querySelector('[data-chips]');
    var subEl = root.querySelector('[data-subchips]');
    var searchEl = root.querySelector('[data-search]');
    var toolsEl = root.querySelector('[data-tools]');
    var gridEl = root.querySelector('[data-grid]');
    var moreEl = root.querySelector('[data-more]');
    var countEl = null;

    /* chips-only mode: family links to the subject collections; inside a family, its specific subjects too */
    if (mode === 'chips') {
      var cur = (location.pathname.match(/\/collections\/([^\/?#]+)/) || [])[1];
      var curFam = null;
      FAMILIES.forEach(function (f) { if (f[1] === cur || f[2].some(function (c) { return c[1] === cur; })) curFam = f; });
      chipsEl.innerHTML = FAMILIES.map(function (f) {
        return '<a class="sb-chip' + (curFam === f ? ' on' : '') + '" href="/collections/' + f[1] + '">' + esc(f[0]) + '</a>';
      }).join('') + '<a class="sb-chip sb-sub" href="' + esc(browseUrl) + '">Search everything &rarr;</a>';
      if (curFam && subEl) {
        subEl.innerHTML = curFam[2].filter(function (c) { return c[1]; }).map(function (c) {
          return '<a class="sb-chip sb-sub' + (c[1] === cur ? ' on' : '') + '" href="/collections/' + c[1] + '">' + esc(c[0]) + '</a>';
        }).join('');
        subEl.hidden = !subEl.innerHTML;
      }
      return;
    }

    var state = { subject: param('subject') || (location.hash ? decodeURIComponent(location.hash.slice(1)) : '') || '', q: param('q') || '', kind: '', size: '', sort: 'newest', sold: false, shown: 0 };
    var items = [], filtered = [], cols = [];

    function counts() { var c = {}; items.forEach(function (it) { it.subjects.forEach(function (s) { c[s] = (c[s] || 0) + 1; }); }); return c; }

    function renderChips() {
      if (!chipsEl) return;
      var c = counts();
      var fam = familyOf(state.subject);
      var html = '<button type="button" class="sb-chip' + (state.subject ? '' : ' on') + '" data-subject="">All</button>';
      FAMILIES.forEach(function (f) {
        var n = 0; items.forEach(function (it) { if (it.subjects.some(function (s) { return familySubjects(f).indexOf(s) > -1; })) n++; });
        if (!n) return;
        html += '<button type="button" class="sb-chip' + (fam === f ? ' on' : '') + '" data-subject="' + esc(f[0]) + '">' + esc(f[0]) + ' <small>' + n + '</small></button>';
      });
      chipsEl.innerHTML = html;
      if (subEl) {
        if (fam && fam[2].length) {
          var sh = '<button type="button" class="sb-chip sb-sub' + (state.subject === fam[0] ? ' on' : '') + '" data-subject="' + esc(fam[0]) + '">All ' + esc(fam[0].toLowerCase()) + '</button>';
          fam[2].forEach(function (ch) { if (!c[ch[0]]) return; sh += '<button type="button" class="sb-chip sb-sub' + (state.subject === ch[0] ? ' on' : '') + '" data-subject="' + esc(ch[0]) + '">' + esc(ch[0]) + ' <small>' + c[ch[0]] + '</small></button>'; });
          subEl.innerHTML = sh; subEl.hidden = false;
        } else { subEl.innerHTML = ''; subEl.hidden = true; }
      }
    }
    function renderTools() {
      if (!toolsEl) return;
      var html = '<span class="sb-lbl">Show</span>';
      html += '<button type="button" class="sb-chip sb-sub' + (state.kind ? '' : ' on') + '" data-kind="">Everything</button>';
      KINDS.forEach(function (k) { html += '<button type="button" class="sb-chip sb-sub' + (state.kind === k[0] ? ' on' : '') + '" data-kind="' + k[0] + '">' + k[1] + '</button>'; });
      html += '<span class="sb-sep"></span><span class="sb-lbl">Size</span>';
      SIZES.forEach(function (s) { html += '<button type="button" class="sb-chip sb-sub' + (state.size === s[0] ? ' on' : '') + '" data-size="' + esc(s[0]) + '">' + s[1] + '</button>'; });
      html += '<span class="sb-sep"></span><button type="button" class="sb-chip sb-sub' + (state.sold ? ' on' : '') + '" data-sold="1">Include sold</button>';
      html += '<select class="sb-sort" data-sort><option value="newest">Newest first</option><option value="low">Price: low to high</option><option value="high">Price: high to low</option></select>';
      html += '<span class="sb-count" data-count></span>';
      toolsEl.innerHTML = html;
      toolsEl.querySelector('[data-sort]').value = state.sort;
      countEl = toolsEl.querySelector('[data-count]');
    }
    function matchesSubject(it) {
      if (!state.subject) return true;
      var fam = familyOf(state.subject);
      var want = (fam && fam[0] === state.subject) ? familySubjects(fam) : [state.subject];
      return it.subjects.some(function (s) { return want.indexOf(s) > -1; });
    }
    function matchesQuery(it) {
      if (!state.q) return true;
      var toks = state.q.toLowerCase().split(/\s+/).filter(Boolean);
      return toks.every(function (tk) { return it.hay.indexOf(tk) > -1; });
    }
    function applyFilter() {
      filtered = items.filter(function (it) {
        if (!matchesSubject(it) || !matchesQuery(it)) return false;
        if (state.kind && it.kind !== state.kind) return false;
        if (state.size && it.sizes.indexOf(state.size) < 0) return false;
        if (!state.sold && !it.avail) return false;
        return true;
      });
      filtered.sort(function (a, b) {
        if (state.sort === 'low') return a.price - b.price;
        if (state.sort === 'high') return b.price - a.price;
        return b.created - a.created;
      });
      /* 2026-10-02 (Cole: "Fresh and Find look exactly the same"): on the homepage, before anyone searches or picks a
         family, Find A Drawing shows a shuffled mix from the whole shop and pushes the newest originals (the ones
         Fresh Off The Drawing Board already shows) to the back. The order is stable for the visit. */
      if (mode === 'compact' && !state.subject && !state.q) {
        var newest = filtered.filter(function (it) { return it.kind === 'original'; }).slice(0, freshSkip);
        var rest = filtered.filter(function (it) { return newest.indexOf(it) < 0; });
        var seed = 1;
        try { seed = parseInt(sessionStorage.getItem('sxfb_seed'), 10) || 0; if (!seed) { seed = Math.floor(Math.random() * 1e9) + 1; sessionStorage.setItem('sxfb_seed', String(seed)); } } catch (e) { seed = 12345; }
        function rnd() { seed = (seed * 16807) % 2147483647; return seed / 2147483647; }
        for (var i = rest.length - 1; i > 0; i--) { var j = Math.floor(rnd() * (i + 1)); var t = rest[i]; rest[i] = rest[j]; rest[j] = t; }
        filtered = rest.concat(newest);
      }
      if (countEl) countEl.textContent = filtered.length + (filtered.length === 1 ? ' drawing' : ' drawings');
    }
    function colCount() { var w = gridEl.clientWidth || 900; return Math.max(2, Math.min(5, Math.floor(w / (w < 750 ? 170 : 240)))); }
    function buildCols() {
      gridEl.innerHTML = ''; cols = [];
      for (var i = 0, n = colCount(); i < n; i++) { var d = document.createElement('div'); d.className = 'sb-col'; d.setAttribute('data-h', '0'); gridEl.appendChild(d); cols.push(d); }
    }
    function card(it) {
      var a = document.createElement('a');
      a.className = 'sb-item' + (it.avail ? '' : ' sold');
      a.href = '/products/' + it.handle;
      a.innerHTML = '<img loading="lazy" src="' + esc(imgUrl(it.src, 600)) + '" width="' + it.w + '" height="' + it.h + '" alt="' + esc(it.name) + '" style="aspect-ratio:' + it.w + '/' + it.h + '">' +
        '<div class="sb-cap"><span class="sb-name">' + esc(it.name) + '</span><span class="sb-meta">' + esc(it.meta) + '</span><span class="sb-price">' + esc(it.priceText) + '</span></div>';
      return a;
    }
    function place(it) { /* shortest column wins — heights estimated from aspect ratio, like the archive masonry */
      var best = cols[0], bh = Infinity;
      cols.forEach(function (c) { var h = parseFloat(c.getAttribute('data-h')); if (h < bh) { bh = h; best = c; } });
      best.appendChild(card(it));
      best.setAttribute('data-h', bh + (1 / it.ar) * 100 + 22);
    }
    function renderBatch(n) {
      var end = Math.min(filtered.length, state.shown + n);
      for (var i = state.shown; i < end; i++) place(filtered[i]);
      state.shown = end;
      updateMore();
    }
    function updateMore() {
      if (!moreEl) return;
      var rest = filtered.length - state.shown;
      if (mode === 'collection') {
        moreEl.innerHTML = rest > 0 ? '<a class="sb-btn" href="/collections/' + esc(collection) + '">View all ' + filtered.length + ' &rarr;</a>' : '';
      } else if (mode === 'compact') {
        var qs = [];
        if (state.subject) qs.push('subject=' + encodeURIComponent(state.subject));
        if (state.q) qs.push('q=' + encodeURIComponent(state.q));
        var label = rest > 0 ? 'See all ' + filtered.length + (state.subject ? ' ' + esc(state.subject.toLowerCase()) : state.q ? ' for &ldquo;' + esc(state.q) + '&rdquo;' : '') + ' &rarr;' : 'Search everything &rarr;';
        moreEl.innerHTML = '<a class="sb-btn" href="' + esc(browseUrl + (qs.length ? '?' + qs.join('&') : '')) + '">' + label + '</a>';
      } else {
        moreEl.innerHTML = rest > 0 ? '<button type="button" class="sb-btn" data-loadmore>Show more (' + rest + ' left)</button>' : '';
      }
    }
    function rerender() {
      applyFilter(); buildCols(); state.shown = 0;
      if (!filtered.length) {
        gridEl.innerHTML = '<div class="sb-empty">' + (state.q ? 'Nothing matches &ldquo;' + esc(state.q) + '&rdquo; right now. ' : 'Nothing here right now. ') + '<a href="/products/custom-artwork">Want one drawn?</a></div>';
        if (moreEl) moreEl.innerHTML = ''; return;
      }
      renderBatch(mode === 'full' ? 24 : limit);
    }
    function redistribute() { var shown = state.shown; buildCols(); state.shown = 0; renderBatch(shown); }
    function syncUrl() { if (mode !== 'full') return; try { var qs = []; if (state.subject) qs.push('subject=' + encodeURIComponent(state.subject)); if (state.q) qs.push('q=' + encodeURIComponent(state.q)); history.replaceState(null, '', qs.length ? '?' + qs.join('&') : location.pathname); } catch (x) {} }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-subject],[data-kind],[data-size],[data-sold],[data-loadmore]');
      if (!b) return;
      if (b.hasAttribute('data-loadmore')) { renderBatch(24); return; }
      if (b.hasAttribute('data-subject')) { state.subject = b.getAttribute('data-subject'); renderChips(); syncUrl(); }
      if (b.hasAttribute('data-kind')) { state.kind = b.getAttribute('data-kind'); renderTools(); }
      if (b.hasAttribute('data-size')) { state.size = state.size === b.getAttribute('data-size') ? '' : b.getAttribute('data-size'); renderTools(); }
      if (b.hasAttribute('data-sold')) { state.sold = !state.sold; renderTools(); }
      rerender();
    });
    root.addEventListener('change', function (e) { if (e.target.matches('[data-sort]')) { state.sort = e.target.value; rerender(); } });
    if (searchEl) {
      var inp = searchEl.querySelector('input'), st;
      inp.value = state.q;
      inp.addEventListener('input', function () { clearTimeout(st); st = setTimeout(function () { state.q = inp.value.trim(); syncUrl(); rerender(); }, 160); });
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); if (mode === 'compact') { var a = moreEl && moreEl.querySelector('a'); if (a) location.href = a.href; } } });
    }
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (cols.length !== colCount()) redistribute(); }, 150); });

    gridEl.innerHTML = '<div class="sb-spin"></div>';
    if (mode === 'collection') {
      load('/collections/' + collection + '/products.json?limit=250', 'sxfb_c_' + collection, function (products) {
        items = parse(products, false); state.sort = 'newest';
        rerender();
      });
    } else {
      load('/products.json?limit=250', 'sxfb3', function (products) {
        items = parse(products, true);
        if (state.subject && !familyOf(state.subject)) state.subject = '';
        renderChips(); renderTools(); rerender();
      });
    }
  }

  roots.forEach(init);
})();
